export enum DepartmentVisibilities {
  Nothing = -1,
  All_Departments = 0,
  Only_User_Department = 1,
}
